module.exports = {
  errors:{
    "INSTRUCTION_TOO_LONG": "Your prompt is too long, exceeding 1000 characters."
  },
  Questionnaire:{
    title:'Literature Review Generation System Questionnaire',
    p1:'Hello, we are a research team from the Department of Computer Science at the Hong Kong Polytechnic University working on automatic literature review generation.',
    p2:'We invite you to take a few minutes to share your feedback and suggestions to help improve our system. If you indicate your consent by continuing to complete this questionnaire, your anonymous responses may be used for future research.',
    submit:"Submit",
    thx:"Thank you for your participation!",
    multiSelectNoResult:"No elements found. Consider changing the search query."
  },
  FooterView: {
    copyright: "Copyright 2025 - All rights reserved.",
    icp: "粤ICP备2024229891号-1",
  },
  HeaderView: {
    HeaderHome: {
      backToHome: "Home",
    },
    HeaderTutorial: {
      usageInstructions: "Tutorial",
      comingSoon: "Coming Soon",
      close: "Close",
    },
    HeaderFAQ:{
      faq:'FAQ',
      answerText:'Answer',
    },
    HeaderTerms: {
      disclaimer: "Terms of Use",
      p_0:"This tool is developed solely for academic research purposes and is intended exclusively for lawful, non-commercial research activities. Please carefully read the following terms before use. By starting to use this tool, the user explicitly acknowledges and agrees to all terms stated hereunder:",
      h4_1:"Disclaimer",
      p_1_a:"The content generated by this tool may include automated analytical results based on publicly available literature, and does not constitute the development team's endorsement regarding the accuracy, legality, or ethical nature of such content. Users should consult qualified professionals within relevant fields before making decisions based on generated content.",
      p_1_b:"The development team has implemented reasonable technical measures to ensure content quality, but assumes no liability for inaccuracies resulting from non-malicious errors or technical limitations. Users must carefully verify the accuracy and applicability of generated content, especially in high-risk fields such as medicine, finance, and law.",
      p_1_c:"Users explicitly understand and accept that, due to technical limitations inherent in this tool, generated reports might contain errors or inaccuracies. The development team shall not be held responsible for any loss or damage arising from the user's failure to adequately verify generated content or from misuse thereof.",
      h4_2:"Prohibited Conduct and Liability",
      p_2_a:"Users are prohibited from using this tool for any purposes that violate laws and regulations, public order and morality, or infringe upon intellectual property rights, including but not limited to illegal, harmful, violent, discriminatory (racial or otherwise), pornographic, defamatory, privacy-infringing, or otherwise inappropriate purposes.",
      p_2_b:"Should a user breach the above provisions, the development team reserves the right to terminate services and pursue relevant legal liabilities.",
      h4_3:"Privacy Policy",
      p_3_a:"This tool respects and protects user privacy, and by default does not actively collect or share personal user data.",
      p_3_b:"To optimize service performance, the development team may collect anonymized usage data (such as access times, types of operations, device categories, or technical logs like IP addresses). Such data cannot be linked to personal identities. We strictly comply with relevant laws and regulations (including but not limited to GDPR and CCPA), and apply reasonable security measures to store, encrypt, and periodically delete the collected data.",
      h4_4:"User Rights and Service Termination",
      p_4_a:"Users have the sole discretion to use the research preview functionality provided by this tool and retain the right to discontinue use at any time.",
      p_4_b:"The development team reserves the right to suspend or terminate services due to violations of these Terms of Use, or for technical maintenance, upgrades, or other reasons, and will give prior notice to users under reasonable circumstances.",
      h4_5:"Governing Law and Dispute Resolution",
      p_5_a:"These Terms of Use are governed by the laws of the People's Republic of China. Any disputes arising from the use of this tool or related to these terms shall first be resolved through amicable negotiations. Should negotiations fail, both parties agree to submit the dispute to the jurisdiction of the People's Court located in the same region as the development team.",
      h4_6:"Validity and Amendments of Terms",
      p_6_a:"These terms are prominently displayed upon the user's initial use or registration page. Users must explicitly read and agree to these terms before using this tool. The development team reserves the right to modify or update these terms as deemed necessary. Users will be promptly notified of any amendments. Continued use of this tool by the user constitutes acceptance of the updated terms.",
      h4_7:"Contact Information",
      p_7_a:"If you have any questions, comments, or complaints regarding the functionality of this tool, privacy protection measures, content of these Terms of Use, potential risks or benefits, please contact us via our online feedback channel or by email at service.write4u{'@'}outlook.com. ",
      p_7_b:"Please do NOT contact the authors of generated articles directly!",
      p_7_c:"The development team reserves the right of final interpretation of these Terms of Use.",
      content: `<p class="my-2 text-base text-slate-800 dark:text-black">
      This tool is developed solely for academic research purposes and is intended exclusively for lawful, non-commercial research activities. Please carefully read the following terms before use. By starting to use this tool, the user explicitly acknowledges and agrees to all terms stated hereunder:
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">Disclaimer</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      The content generated by this tool may include automated analytical results based on publicly available literature, and does not constitute the development team's endorsement regarding the accuracy, legality, or ethical nature of such content. Users should consult qualified professionals within relevant fields before making decisions based on generated content.
    </p>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      The development team has implemented reasonable technical measures to ensure content quality, but assumes no liability for inaccuracies resulting from non-malicious errors or technical limitations. Users must carefully verify the accuracy and applicability of generated content, especially in high-risk fields such as medicine, finance, and law.
    </p>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      Users explicitly understand and accept that, due to technical limitations inherent in this tool, generated reports might contain errors or inaccuracies. The development team shall not be held responsible for any loss or damage arising from the user's failure to adequately verify generated content or from misuse thereof.
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">Prohibited Conduct and Liability</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      Users are prohibited from using this tool for any purposes that violate laws and regulations, public order and morality, or infringe upon intellectual property rights, including but not limited to illegal, harmful, violent, discriminatory (racial or otherwise), pornographic, defamatory, privacy-infringing, or otherwise inappropriate purposes.
    </p>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      Should a user breach the above provisions, the development team reserves the right to terminate services and pursue relevant legal liabilities.
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">Privacy Policy</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      This tool respects and protects user privacy, and by default does not actively collect or share personal user data.
    </p>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      To optimize service performance, the development team may collect anonymized usage data (such as access times, types of operations, device categories, or technical logs like IP addresses). Such data cannot be linked to personal identities. We strictly comply with relevant laws and regulations (including but not limited to GDPR and CCPA), and apply reasonable security measures to store, encrypt, and periodically delete the collected data.
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">User Rights and Service Termination</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      Users have the sole discretion to use the research preview functionality provided by this tool and retain the right to discontinue use at any time.
    </p>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      The development team reserves the right to suspend or terminate services due to violations of these Terms of Use, or for technical maintenance, upgrades, or other reasons, and will give prior notice to users under reasonable circumstances.
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">Governing Law and Dispute Resolution</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      These Terms of Use are governed by the laws of the People's Republic of China. Any disputes arising from the use of this tool or related to these terms shall first be resolved through amicable negotiations. Should negotiations fail, both parties agree to submit the dispute to the jurisdiction of the People's Court located in the same region as the development team.
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">Validity and Amendments of Terms</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      These terms are prominently displayed upon the user's initial use or registration page. Users must explicitly read and agree to these terms before using this tool. The development team reserves the right to modify or update these terms as deemed necessary. Users will be promptly notified of any amendments. Continued use of this tool by the user constitutes acceptance of the updated terms.
    </p>
    <h4 class="text-lg font-medium text-slate-800 dark:text-black">Contact Information</h4>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      If you have any questions, comments, or complaints regarding the functionality of this tool, privacy protection measures, content of these Terms of Use, potential risks or benefits, please contact us via our online feedback channel or by email at <a class='underline' href='mailto:service.write4u{'@'}outlook.com'>service.write4u{'@'}outlook.com</a>. <strong>Please do NOT contact the authors of generated articles directly!</strong>
    </p>
    <p class="my-2 text-base text-slate-800 dark:text-black">
      The development team reserves the right of final interpretation of these Terms of Use.
    </p>`,
      disagree: "Disagree",
      agree: "I have read and agree",
    },
    HeaderAbout: {
      aboutUs: "About",
      researchTeam: "About us",
      research:"Research Team",
      develop:"Development Team",
      close: "Close",
      note1: "If you have any queries or comments, you can contact service.write4u{'@'}outlook.com and we will follow up as soon as possible. ", // eslint-disable-line
      note2: "Please do not contact the author directly!", // eslint-disable-line
      note3: "", // eslint-disable-line
      first_p1:"WriteForYou is a demo of our paper",
      first_p2:" published at AAAI 2025. Based on this work, we are expanding it into a journal paper. The AAAI reviewers suggested that we should gather more feedback from actual users. If you could spare a moment to fill out a",
      first_p3:"when using the WriteForYou, we would greatly appreciate it! ",
      user_feedback:"User Feedback Form"
    },
    HeaderFeedback: {
      feedback: "Feedback",
      subject: "Subject",
      subjectPlaceholder: "Please enter the subject...",
      email: "Email",
      emailPlaceholder: "Please enter your email...",
      anonymous: "Anonymous",
      contactMe: "Contact Me",
      content: "Content",
      feedbackSuccess: "Feedback successfully",
      feedbackFailed: "Feedback failed, please try again later",
      contentPlaceholder:
        "For example, please add the format template of a conference...",
      note: "Note: Please do not contact the author directly. If you have any questions, please contact wirteforyou{'@'}gmail.com.", // eslint-disable-line
      note1: "If you have any queries or comments, you can type them directly in the text box above or fill out a ", // eslint-disable-line
      questionnaireBtn:'Feedback Form',
      note11:" or contact service.write4u{'@'}outlook.com and we will follow up as soon as possible. ",
      note2: "Please do not contact the author directly!", // eslint-disable-line
      note3: "", // eslint-disable-line
      cancel: "Cancel",
      submit: "Submit",
      attachInfomation:
        "If you don't mind, please provide the following information",
      attachSettings: "Your settings",
      attachScreenshot: "Your generation results",
    },
    HeaderNews: {
      latestAnnouncement: "Announcement",
      comingSoon: "Coming Soon",
      close: "Close",
    },
  },
  ShowMoreDown: {
    showMore: "Show More",
    hideMore: "Hide Options",
  },
  RadioGroupMore: {
    showMore: "Show More",
  },
  FileUpload: {
    dragAndDrop: "Drag and drop a file here, or",
    clickToUpload: "click to upload",
    supportedFormats: "Support",
    currentFile: "Current File:",
    wrongFormat: "Please upload a file in the formats of .docx, .png, .jpg, or .pdf",
    wrongFileSize:"Please upload a file smaller than 10MB"
  },
  ProgressAPI: {
    titleText: "Task Progress",
    completedTasksText: "Tasks completed.",
    retryText: "Retry",
    remainingTimeText: "Time remaining",
    estimateRemainingTimeText: "Estimating remaining time.",
    completedText: "Completed",
    secondsText: "seconds",
  },
  HomeView: {
    HomeWelcome: {
      writeForYou: "WRITE FOR YOU",
      writeForYouSubtitle: "帮你写",
      writeForYouDescription:
        "Trustworthy Literature Review in One Click",
      lightMode: "Light Mode",
      darkMode: "Dark Mode",
    },
    HomeInput: {
      uploadFile: "Upload File",
      cancel: "Cancel",
      submit: "Submit",
      textInstruction: "Text Requirement",
      textInstructionTitle: "Requirement",
      textInstructionPlaceholder:
        "For example, generate a review report about artificial intelligence.",
      instructionPlaceholder:
        "You can enter the generation requirements, or press the button on the right to upload a description file (.pdf, .docx, .jpg, .jpeg, .png)",
    },
    HomeWords: {
      words: "Words",
      wordsUnit: "words",
      wordsPlaceholder: "Please enter the words...",
      confirm: "OK",
    },
    HomeGenerate: {
      generate: "Generate",
      waitTime: "Wait:",
      minutes: "minutes",
      instruction: "Please enter or upload the instruction",
      noSources: "Please select at least one source from the English and Chinese databases.",
      inviteCodeLabel: "Please enter the invite code",
      inviteCodePlaceholder: "Please enter the invite code",
      vipNote: "Due to the large number of users, the server is currently under heavy load. Please limit the generation time to 1 hour.",
      vipTitle: "Your generation time is long",
      currentTime: "Current generation time is",
      vipNote2: "You can adjust your settings or use an invite code to generate for more than 1 hour. Thank you for your support!",
      confirm: "Confirm",
      cancel: "Cancel",
      inviteCodeError: "Invite code error",
    },
    HomeForm: {
      advancedSettings: "Advanced Settings",
      numCitations: "Number of Citations",
      numCitationsPlaceholder: "Please enter the number of citations...",
      template: "Report Template",
      abstract: "Abstract Settings",
      otherAttachments: "Meantime Generate",
      appendix: "Report Appendix",
      diagram: "Report Diagram",
      sources: "Report Reference Sources",
      plugins: "Report Enhance Tools"
    },
    HomeProgress: {
      createSectionPlans: "Creating section plans.",
      createSectionContents: "Creating section contents.",
      searchRelatedPapers: "Searching related papers.",
      createPaperInfo: "Creating paper information.",
      createSectionDiagrams: "Creating section diagrams.",
      createPaperElements: "Rendering paper template.",
      downloadPaper: "Downloading paper file.",
      sendPaperEmail: "Sending email.",
      downloadPDF: "Downloading PDF.",
      emailHint:
        "Please enter your email, we will send the generated file to your email. After sending, we will not retain your email or personal information.",
      emailPlaceholder: "Please enter your email...",
      subscribe: "Send Email",
      message: "Settings updated, please check your email.",
      startNext: "Home Page",
      questionnaireDesc:"While you're waiting, if you've viewed the generated content and you don't mind, you can help us fill out a ",
      questionnaireBtn:"questionnaire feedback form ",
      questionnaireDesc2:"(takes about 1 minute). ：)",
      noAllowed:"Please return to Home Page to input or upload the generation requirements first. "
    },
    DownloadPaper: {
      download: "Download Paper",
    },
  },
};
